<script setup lang="ts">
    import {computed} from 'vue';
    import {parseMessage} from './markdown';

    const props = defineProps<{
        label: string;
        text: string;
        tone: 'me' | 'ai' | 'error';
    }>();

    const blocks = computed(() => parseMessage(props.text));
</script>

<template>
    <div :class="['chat-bubble', tone === 'error' ? 'chat-bubble--error c-notification--warn' : `chat-bubble--${tone}`]" :role="tone === 'error' ? 'alert' : undefined">
        <span class="sr-only">{{ label }}:</span>
        <template v-if="tone === 'me'">{{ text }}</template>
        <template v-else>
            <template
                v-for="(block, blockIndex) in blocks"
                :key="blockIndex">
                <table
                    v-if="block.type === 'table'"
                    class="table table-bordered chat-table">
                    <thead>
                        <tr>
                            <th
                                v-for="(cell, index) in block.head"
                                :key="index">
                                {{ cell.text }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(row, rowIndex) in block.rows"
                            :key="rowIndex">
                            <td
                                v-for="(cell, cellIndex) in row"
                                :key="cellIndex">
                                <template
                                    v-for="(span, spanIndex) in cell"
                                    :key="spanIndex">
                                    <strong v-if="span.bold">{{ span.text }}</strong>
                                    <template v-else>{{ span.text }}</template>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span v-else>
                    <template
                        v-for="(line, lineIndex) in block.lines"
                        :key="lineIndex">
                        <br v-if="lineIndex > 0" />
                        <template
                            v-for="(span, spanIndex) in line"
                            :key="spanIndex">
                            <strong v-if="span.bold">{{ span.text }}</strong>
                            <template v-else>{{ span.text }}</template>
                        </template>
                    </template>
                </span>
            </template>
        </template>
    </div>
</template>
